import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { useAuth } from '../../contexts/AuthContext';
import { t } from '../../translations';

/**
 * DateFormatSelector Component
 * Allows users to select their preferred date format
 * Shows for ALL users (not just US)
 */
const DateFormatSelector = ({ className = '' }) => {
  const { dateFormat, language, setDateFormat } = useLocale();
  const { updateUserProfile } = useAuth();

  const formatOptions = [
    { value: 'MM/DD/YYYY', label: t(language, 'dateFormat.usFormat'), example: '03/15/2024' },
    { value: 'DD/MM/YYYY', label: t(language, 'dateFormat.intlFormat'), example: '15/03/2024' },
    { value: 'YYYY-MM-DD', label: t(language, 'dateFormat.isoFormat'), example: '2024-03-15' }
  ];

  const handleFormatChange = (e) => {
    const newFormat = e.target.value;
    // Pass updateUserProfile function to save to Firebase
    setDateFormat(newFormat, updateUserProfile);
  };

  const selectedOption = formatOptions.find(opt => opt.value === dateFormat);

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      <label htmlFor="date-format-selector" className="text-sm font-medium text-gray-700">
        {t(language, 'dateFormat.label')}:
      </label>

      <select
        id="date-format-selector"
        value={dateFormat}
        onChange={handleFormatChange}
        className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500 text-sm"
      >
        {formatOptions.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {selectedOption && (
        <span className="text-sm text-gray-500">
          {t(language, 'dateFormat.preview')} <span className="font-medium text-gray-700">{selectedOption.example}</span>
        </span>
      )}
    </div>
  );
};

export default DateFormatSelector;
